import { initErrorHandler } from './error-handler'
import { addMenu } from './menu'
import { initUserState } from './user-utils'

export async function initPage() {
  initErrorHandler()
  addMenu()
  await initUserState()
}
